import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';
import { messages } from './surgery.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class SurgeryDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    const laterality = isNullOrWhiteSpace(this.props.surgery.lateralityDisplay) ?
      this.props.surgery.laterality :
      this.props.surgery.lateralityDisplay;
    return (
      this.props.surgery.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'surgery_' + this.props.surgery.procedureName}>
        <div className="col-md-4 primary-data">
          {
            this.props.surgery.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.surgery.procedureName}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.startDate} />}
                value={this.props.surgery.startDate} language={this.props.language} isDate
                isActive={this.configurationActive('StartDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.laterality} />}
                value={laterality} language={this.props.language}
                isActive={this.configurationActive('Laterality')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.provider} />}
                value={this.props.surgery.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.surgery.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.surgery.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.surgery.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.surgery.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="surgery_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.surgery.nullMessage}
        </div>
      </div>
    );
  }
}

SurgeryDetail.propTypes = {
  surgery: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
